// extracted by mini-css-extract-plugin
export default {"cls1":"PaperPreviewList-cls1_Dbv","cls2":"PaperPreviewList-cls2_ZK_ PaperPreviewList-cls1_Dbv"};